/**
 * UCRO Color Swatches - v12
 * - Nivela tarjetas con y sin swatches
 * - Posiciona swatches arriba del título
 * - Funciona en mobile y desktop
 */
(function() {
  'use strict';

  const CONFIG = {
    swatchHeight: 26,        // Altura reservada para swatches en mobile
    swatchHeightDesktop: 24, // Altura reservada para swatches en desktop
    debounceTime: 150
  };

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setTimeout(setup, 100));
    } else {
      setTimeout(setup, 100);
    }
    
    // Observer para nuevos productos (infinite scroll, etc)
    new MutationObserver(() => {
      clearTimeout(window._ucroTimeout);
      window._ucroTimeout = setTimeout(setup, CONFIG.debounceTime);
    }).observe(document.body, { childList: true, subtree: true });

    // Re-ejecutar en resize
    window.addEventListener('resize', () => {
      clearTimeout(window._ucroResizeTimeout);
      window._ucroResizeTimeout = setTimeout(setup, 300);
    });
  }

  function setup() {
    const cards = document.querySelectorAll('product-card, .product-card');
    
    cards.forEach(card => {
      moveSwatchesAboveTitle(card);
      sortSwatchesWithCurrentFirst(card);
      setupHover(card);
    });

    // Nivelar tarjetas después de procesar todas
    setTimeout(levelCards, 50);
  }

  /**
   * Mueve los swatches ARRIBA del título
   */
  function moveSwatchesAboveTitle(card) {
    const swatches = card.querySelector('product-swatches');
    const title = card.querySelector('a.contents[ref="productTitleLink"]');
    
    if (swatches && title && title.parentNode) {
      // Solo mover si no está ya arriba del título
      const swatchesRect = swatches.getBoundingClientRect();
      const titleRect = title.getBoundingClientRect();
      
      if (swatchesRect.top > titleRect.top) {
        title.parentNode.insertBefore(swatches, title);
      }
    }
  }

  /**
   * Nivela todas las tarjetas de producto
   */
  function levelCards() {
    const isMobile = window.innerWidth <= 749;
    const swatchHeight = isMobile ? CONFIG.swatchHeight : CONFIG.swatchHeightDesktop;
    
    document.querySelectorAll('product-card, .product-card').forEach(card => {
      const swatches = card.querySelector('product-swatches');
      const hasVisibleSwatches = swatches && swatches.querySelector('li.variant-option__swatch');
      
      // Obtener el contenedor del contenido
      const contentContainer = card.querySelector('.group-block-content');
      
      if (!hasVisibleSwatches) {
        // Producto SIN swatches - agregar espacio
        if (swatches) {
          swatches.style.minHeight = swatchHeight + 'px';
          swatches.style.height = swatchHeight + 'px';
          swatches.style.display = 'block';
        } else if (contentContainer) {
          // Si no existe product-swatches, agregar padding
          contentContainer.style.paddingTop = swatchHeight + 'px';
        }
      } else {
        // Producto CON swatches - asegurar altura mínima
        if (swatches) {
          swatches.style.minHeight = swatchHeight + 'px';
        }
      }
    });

    // Nivelar filas de productos
    levelProductRows();
  }

  /**
   * Nivela las filas de productos para que tengan la misma altura
   */
  function levelProductRows() {
    const isMobile = window.innerWidth <= 749;
    if (!isMobile) return; // Solo en mobile

    // Obtener todas las tarjetas visibles
    const cards = Array.from(document.querySelectorAll('product-card, .product-card'));
    if (cards.length < 2) return;

    // Agrupar tarjetas por fila (basado en posición Y)
    const rows = [];
    let currentRow = [];
    let currentTop = -1;

    cards.forEach(card => {
      const rect = card.getBoundingClientRect();
      const top = Math.round(rect.top);

      if (currentTop === -1 || Math.abs(top - currentTop) < 50) {
        currentRow.push(card);
        if (currentTop === -1) currentTop = top;
      } else {
        if (currentRow.length > 0) rows.push(currentRow);
        currentRow = [card];
        currentTop = top;
      }
    });
    if (currentRow.length > 0) rows.push(currentRow);

    // Para cada fila, igualar la altura del contenido
    rows.forEach(row => {
      if (row.length < 2) return;

      // Resetear alturas primero
      row.forEach(card => {
        const content = card.querySelector('.group-block-content');
        if (content) content.style.minHeight = '';
      });

      // Encontrar la altura máxima
      let maxHeight = 0;
      row.forEach(card => {
        const content = card.querySelector('.group-block-content');
        if (content) {
          const height = content.offsetHeight;
          if (height > maxHeight) maxHeight = height;
        }
      });

      // Aplicar altura máxima a todas
      row.forEach(card => {
        const content = card.querySelector('.group-block-content');
        if (content && maxHeight > 0) {
          content.style.minHeight = maxHeight + 'px';
        }
      });
    });
  }

  /**
   * Ordena swatches: PRIMERO el color actual, luego relacionados
   */
  function sortSwatchesWithCurrentFirst(card) {
    if (card.dataset.ucroSorted === 'true') return;
    
    const container = card.querySelector('overflow-list');
    if (!container) return;
    
    const allSwatches = Array.from(container.querySelectorAll('li.variant-option__swatch'));
    if (allSwatches.length < 1) return;
    
    const currentSwatches = allSwatches.filter(s => s.classList.contains('variant-option__swatch--current'));
    const relatedSwatches = allSwatches.filter(s => s.classList.contains('variant-option__swatch--related'));
    
    relatedSwatches.sort((a, b) => {
      return (parseInt(a.dataset.colorOrder) || 50) - (parseInt(b.dataset.colorOrder) || 50);
    });
    
    const sortedSwatches = [...currentSwatches, ...relatedSwatches];
    sortedSwatches.forEach(swatch => container.appendChild(swatch));
    
    card.dataset.ucroSorted = 'true';
  }

  /**
   * Preview de imagen en hover
   */
  function setupHover(card) {
    if (card.dataset.ucroHover === 'true') return;
    
    const gallery = card.querySelector('.card-gallery');
    if (!gallery) return;

    card.querySelectorAll('li.variant-option__swatch--related').forEach(swatch => {
      const imgUrl = swatch.dataset.productImage;
      const url = swatch.dataset.productUrl || swatch.querySelector('a')?.href;
      
      swatch.addEventListener('mouseenter', async () => {
        let src = imgUrl;
        if (!src && url) {
          try {
            const res = await fetch(url.split('?')[0] + '.json');
            const data = await res.json();
            src = data.product?.images?.[0]?.src;
            if (src) src += (src.includes('?') ? '&' : '?') + 'width=600';
          } catch (e) {}
        }
        if (src) {
          card.setAttribute('data-preview-product', 'true');
          let img = gallery.querySelector('.ucro-preview-image');
          if (!img) {
            img = document.createElement('img');
            img.className = 'ucro-preview-image';
            gallery.appendChild(img);
          }
          img.src = src;
          setTimeout(() => img.style.opacity = '1', 10);
          const main = gallery.querySelector('.product-media__image');
          if (main) main.style.opacity = '0';
        }
      });

      swatch.addEventListener('mouseleave', () => {
        card.removeAttribute('data-preview-product');
        const img = gallery.querySelector('.ucro-preview-image');
        if (img) img.style.opacity = '0';
        const main = gallery.querySelector('.product-media__image');
        if (main) main.style.opacity = '1';
      });
    });

    card.dataset.ucroHover = 'true';
  }

  init();
})();
